import { Navigate, Route, Routes } from "react-router-dom";
import React, { Fragment } from "react";
import PrivateRoute from "../../Components/Router/PrivateRoute";
import Substitutions from "../../Pages/Melder/Substitutions";
import SubstitutionsHistory from "../../Pages/Melder/Substitutions/History";
import SubstitutionShow from "../../Pages/Melder/Substitutions/Show";
import WeekReport from "../../Pages/Melder/WeekReport";
import Feedback from "../../Pages/Melder/Feedback";
import Profile from "../../Pages/Profile";
import Login from "../../Pages/Login";
import Admin from "../../Pages/Admin";
import Overview from "../../Pages/Melder/Substitutions/Overview/Dashboard";
import Actueel from "../../Pages/Melder/WeekReport/Actueel";
import History from "../../Pages/Melder/WeekReport/History";
import Users from "../../Pages/Admin/Users";
import GeneralSettings from "../../Pages/Admin/GeneralSettings";
import Logging from "../../Pages/Admin/Logging";
import SearchTable from "../../Pages/Melder/Search";
import Export from "../../Pages/Melder/Export";
import Home from "../../Pages/Vervanger/Home";
import Vervanger from "../../Pages/Vervanger";
import Substitutor from "../../Pages/Vervanger/Substitutor";
import LogOut from "Pages/Logout";
import ForgetPassword from "Pages/ForgetPassword";
import ChangedPassword from "Pages/ChangedPassword"
import Indienen from "Pages/Melder/Indienen";
import IndienenSubstitution from "../../Pages/Melder/Indienen/Verzoek";
import Support from "Pages/Melder/Support";
// const Login = lazy(() => import("../../Pages/Login"));
import Document from "Pages/Melder/Document";
import Forbidden from "Pages/Errors/Forbidden";
// const Verzoeken = lazy(() => import("../../Pages/Verzoeken"));
import WeekReportShow from "Pages/Melder/WeekReport/Show"
import Calendar from "Pages/Melder/Substitutions/Calendar";
import CoordinatorCalendar from "Pages/Coordinator/Verzoeken/Calendar";
import Availability from "Pages/Vervanger/Substitutor/Availability";
import HomeOverview from "../../Pages/Vervanger/Home/Overview/";
import HomeShow from "../../Pages/Vervanger/Home/Show";
import Settings from "../../Pages/Vervanger/Settings";
import VervangerOverview from "../../Pages/Vervanger/Overview";
import VervangerDocumenten from '../../Pages/Vervanger/Document';
import VervangerVerzoeken from '../../Pages/Coordinator/Verzoeken';
import CoordinatorOverview from "Pages/Coordinator/Verzoeken/Default";
import CoordinatorPlanboard from "Pages/Coordinator/Verzoeken/Planboard";
import CoordinatorDetailsPage from "../../Pages/Coordinator/Verzoeken/Show";
import TravelCost from "Pages/Coordinator/TravelCost";
import Distances from "Pages/Coordinator/TravelCost/Distances";
import Calculation from "Pages/Coordinator/TravelCost/Calculation";
import TravelCostOverview from "Pages/Coordinator/TravelCost/Default";
import Weekstaten from "Pages/Coordinator/Weekstaten";
import WeekstatenOverview from "Pages/Coordinator/Weekstaten/Overview"
import Compile from "Pages/Coordinator/Weekstaten/Compile";
import ManageLinks from "Pages/Admin/ManageLinks";
import Links from "Pages/Common/Links";
import Gebruikers from "Pages/Coordinator/Gebruikers";
import GebruikerView from "Pages/Coordinator/Gebruikers/GebruikerView";
import WeeklyStatements from "Pages/Coordinator/Weekstaten/WeeklyStatement";
import Apis from "Pages/Admin/Apis";
import ErrorPage from "Pages/Errors/ErrorPage";
import ResetPassword from "Pages/ResetPassword";
import Sms from "Pages/Admin/Sms";
import Instellingen from "../../Pages/Coordinator/Instellingen";
import Features from "Pages/Coordinator/Instellingen/Features";
import CostCenterUnit from "Pages/Coordinator/Instellingen/CostCenterUnit";
import DayTypes from "Pages/Coordinator/Instellingen/DayTypes";
import SendSMS from "Pages/Coordinator/Beheer/SendSMS";
import ReplacementCodes from "Pages/Coordinator/Instellingen/ReplacementCode";
import Beheer from "Pages/Coordinator/Beheer";
import SchoolsOverview from "Pages/Coordinator/Instellingen/Schools/Default";
import SchoolsView from "Pages/Coordinator/Instellingen/Schools/SchoolsView";
import Contracttypen from "Pages/Coordinator/Instellingen/ContractTypen";
import Reporting from "Pages/Coordinator/Beheer/Reporting";
import PushMessagesDefault from "Pages/Admin/LogPushMessages";
import Exporteren from "Pages/Coordinator/Beheer/Exporteren";
import PermissionDeny from "Pages/Errors/PermissionDeny";
import WijzigenToevoegen from "Pages/Coordinator/Instellingen/ContractTypen/WijzigenToevoegen/index";
import FllterInstellingen from "Pages/Coordinator/Instellingen/ContractTypen/FllterInstellingen/index";
import Besturen from "Pages/Coordinator/Instellingen/Besturen";
import Planning from "Pages/Coordinator/Instellingen/Planning";
import Afas from "Pages/Coordinator/Afas";
import AfasOpenstaand from "Pages/Coordinator/Afas/Openstaand";
import AfasSynchronisatie from "Pages/Coordinator/Afas/Synchronisatie";
import AfasHistorie from "Pages/Coordinator/Afas/Historie";
import AfasConflicten from "Pages/Coordinator/Afas/Conflicten";
import Functies from "Pages/Admin/Functies";
import AdminBesturen from "Pages/Admin/Besturen/index";
import Besturens from "Pages/Admin/Besturen/BesturenView";
import Anonimiseren from "Pages/Admin/Anonimiseren";
import Theme from "Pages/Admin/Theme";
import Default from "Pages/Admin/Rollen";
import Documentenbeheer from "Pages/Coordinator/Beheer/Documentenbeheer";
import Planscreen from "Pages/Coordinator/Verzoeken/Planscreen";
import VervangerZoeken from "Pages/Coordinator/Verzoeken/VervangerZoeken";
import SupportDoc from "Pages/SupportRole/Support";
import DocsGoedkeuren from "Pages/SupportRole/Support/DocsGoedkeuren";
import EvaluationRequest from "Pages/Coordinator/Verzoeken/EvaluationRequest";
import PlanscreenGebruiker from "Pages/Coordinator/Gebruikers/PlanscreenView";
import { GebruikersProvider } from "Pages/Coordinator/Gebruikers/Context/GebruikerContext";
import TravelExpenses from "Pages/Vervanger/TravelExpense";
import DeepLinkHandler from "Pages/Common/DeepLinkHandler";
import LogboekLogin from 'Components/Logging/LogboekLogin'
import LogPersoonsgegevens from "Components/Logging/LogPersoonsgegevens";
import LogboekInzage from "Components/Logging/LogboekInzage";
import LogboekAuthorisatie from "Components/Logging/LogboekAuthorisatie";


const AppMain = () => {
    return (
        <Fragment>
            <Routes>
                <Route element={<PrivateRoute showFor={"requestor"}>
                    <Indienen /></PrivateRoute>} path="/indienen">
                    <Route index element={<IndienenSubstitution />} />
                </Route>

                <Route element={<PrivateRoute showFor="requestor"><Substitutions /></PrivateRoute>} path="/verzoeken">
                    <Route index element={<Overview />} />
                    <Route path="historie" element={<SubstitutionsHistory />} />
                    <Route path=':id' element={<SubstitutionShow />} />
                    <Route path=':id/dagdelen-toevoegen' element={<Calendar />} />
                    <Route path="*" element={<Navigate to="/no-page-found" replace />} />
                </Route>
                <Route element={<PrivateRoute showFor="requestor"><WeekReport /></PrivateRoute>} path="/weekstaat" >
                    <Route path=':id' element={<WeekReportShow />} />
                    <Route index element={<Actueel />} />
                    <Route path='actueel' element={<Actueel />} />
                    <Route path='historie' element={<History />} />
                    <Route path="*" element={<Navigate to="/no-page-found" replace />} />
                </Route>
                <Route element={<PrivateRoute showFor="requestor"><Feedback /></PrivateRoute>} path="/terugkoppeling" />
                <Route element={<PrivateRoute showFor="administrator"><Admin /></PrivateRoute>} path="/beheerder">
                    <Route index element={<Users />} />
                    {/* <Route path='users' element={<Administration/>}/> */}
                    <Route path='besturen' element={<AdminBesturen />} />
                    <Route path='besturen/:id' element={<Besturens />} />
                    <Route path='gebruikers' element={<Users />} />
                     <Route path='logging' element={<Logging />} />
                    <Route path='instellingen' element={<GeneralSettings />} />
                    <Route path='links' element={<ManageLinks />} />
                    <Route path='api' element={<Apis />} />
                    <Route path='admin-sms' element={<Sms />} />
                    <Route path='functies' element={<Functies />} />
                   
                    <Route path='rollen' element={<Default />} />
                    <Route path='anonimiseren' element={<Anonimiseren />} />
                     <Route path='theme' element={<Theme />} />
                    <Route path="logging">
                         <Route path='push-messages' element={<PushMessagesDefault />} />
                        <Route path="Login" element={<LogboekLogin />} />
                        <Route path="Persoonsgegevens" element={<LogPersoonsgegevens />} />
                        <Route path="Inzage" element={<LogboekInzage />} />
                        <Route path="Authorisatie" element={<LogboekAuthorisatie />} />
                    </Route>

                </Route>
                <Route element={<PrivateRoute showFor="substitutor"><Home /></PrivateRoute>} path="/home">
                    <Route index element={<HomeOverview />} />
                    <Route path=":id" element={<HomeShow />} />
                </Route>
                <Route element={<PrivateRoute showFor="substitutor"><Vervanger /></PrivateRoute>} path="/vervanger" />
                <Route element={<PrivateRoute showFor="substitutor"><Substitutor /></PrivateRoute>} path="/beschikbaarheid">
                    <Route index element={<Availability />} />
                </Route>
                <Route element={<PrivateRoute showFor="substitutor"><TravelExpenses /></PrivateRoute>} path="/v-reiskosten" />
                <Route element={<PrivateRoute showFor="substitutor"><VervangerDocumenten /></PrivateRoute>} path="/v-documenten" />
                <Route element={<PrivateRoute showFor="substitutor"><VervangerOverview /></PrivateRoute>} path="/urenoverzicht" />
                <Route element={<PrivateRoute showFor="substitutor"><Settings /></PrivateRoute>} path="/instellingen" />

                <Route element={<PrivateRoute><Profile /></PrivateRoute>} path="/profiel" />

                <Route element={<PrivateRoute showFor="requestor"><SearchTable /></PrivateRoute>} path="/searchsubrequests/:substitute" />

                <Route element={<PrivateRoute showFor="requestor"><Export /></PrivateRoute>} path="/export" />
                <Route element={<PrivateRoute><Support /></PrivateRoute>} path="/support" />
                <Route element={<PrivateRoute showFor="requestor"><Document /></PrivateRoute>} path="/documenten" />

                <Route element={<PrivateRoute showFor="coordinator"><VervangerVerzoeken /></PrivateRoute>} path="/verzoeken">
                    <Route index element={<CoordinatorOverview />} />
                    <Route element={<CoordinatorOverview />} path='overzicht' />
                    <Route element={<CoordinatorDetailsPage />} path='overzicht/:id' />
                    <Route element={<CoordinatorCalendar />} path='overzicht/:id/dagdelen-toevoegen' />
                    <Route element={<CoordinatorPlanboard />} path="planbord" />
                    <Route element={<IndienenSubstitution />} path="indienen" />
                    <Route element={<Planscreen />} path="planscreen/:id/:dayId" />
                    <Route element={<VervangerZoeken />} path="vervanger-zoeken/:subsId/:dayId/:id" />
                    <Route path="*" element={<Navigate to="/no-page-found" replace />} />
                </Route>
                <Route element={<PrivateRoute showFor={'coordinator'}><GebruikersProvider><PlanscreenGebruiker /></GebruikersProvider></PrivateRoute>} path="/verzoeken/planscreen/:subsId/:dayId/:contractId/gebruikers/:gebruikerId" />

                <Route element={<PrivateRoute showFor="coordinator"><TravelCost /></PrivateRoute>} path="/reiskosten" >
                    <Route element={<TravelCostOverview />} path='overzicht' />
                    <Route element={<Distances />} path="afstanden" />
                    <Route element={<Calculation />} path="samenstellen" />
                </Route>
                <Route element={<PrivateRoute showFor="coordinator"><Weekstaten /></PrivateRoute>} path="/weekstaten" >
                    <Route index element={<WeekstatenOverview />} path='overzicht' />
                    <Route element={<WeeklyStatements />} path=':id' />
                    <Route element={<Compile />} path="samenstellen" />
                </Route>
                <Route element={<PrivateRoute showFor="coordinator" requireAfasAccess><Afas /></PrivateRoute>} path="/afas">
                    <Route index element={<Navigate to="openstaand" replace />} />
                    <Route element={<AfasOpenstaand />} path="openstaand" />
                    <Route element={<AfasSynchronisatie />} path="synchronisatie" />
                    <Route element={<AfasHistorie />} path="historie" />
                    <Route element={<AfasConflicten />} path="conflicten" />
                </Route>
                <Route element={<PrivateRoute showFor="coordinator"><Instellingen /></PrivateRoute>} path="/c-instellingen">
                    <Route index element={<Besturen />} />
                    <Route path="functies" element={<Features />} />
                    <Route path="dagtypen" element={<DayTypes />} />
                    <Route path="vervangingscodes" element={<ReplacementCodes />} />
                    <Route path="Kp-Kd" element={<CostCenterUnit />} />
                    <Route path="scholen" element={<SchoolsOverview />} />
                    <Route path="scholen/:communityId/:schoolId" element={<SchoolsView />} />
                    <Route path="contracttypen" element={<Contracttypen />} />
                    <Route path="contracttypen/wijzigen-toevoegen/:id" element={<WijzigenToevoegen />} />
                    <Route path="contracttypen/filterinstellingen/:id" element={<FllterInstellingen />} />
                    <Route path="besturen" element={<Besturen />} />
                    <Route path="planning" element={<Planning />} />
                </Route>
                 <Route element={<PrivateRoute showFor={"coordinator"} ><Reporting /> </PrivateRoute>} path="/rapportage" />
                <Route element={<PrivateRoute showFor="coordinator"><Beheer /></PrivateRoute>} path="/overig">
                  
                    <Route path="sms-versturen" element={<SendSMS />} /> 
                    <Route path="exporteren" element={<Exporteren />} />
                    <Route path="documentenbeheer" element={<Documentenbeheer />} />
                    <Route path="Persoonsgegevens" element={<LogPersoonsgegevens />} />
                    <Route path="Inzage" element={<LogboekInzage />} />
                    <Route path="Authorisatie" element={<LogboekAuthorisatie />} />
                </Route>
                <Route element={<PrivateRoute showFor={"coordinator"}><Gebruikers /></PrivateRoute>} path="/gebruikers"></Route>
                <Route element={<PrivateRoute showFor={"coordinator"}><GebruikersProvider><GebruikerView /></GebruikersProvider></PrivateRoute>} path="/gebruikers/:gebruikerId"></Route>
                <Route element={<PrivateRoute showFor={"coordinator"}><Links /></PrivateRoute>} path="/links/coordinator"></Route>
                <Route element={<PrivateRoute showFor={"requestor"}><Links /></PrivateRoute>} path="/links/requestor"></Route>
                <Route element={<PrivateRoute showFor={"substitutor"}><Links /></PrivateRoute>} path="/links/substitutor"></Route>


                <Route element={<Forbidden />} path="/no-access" />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/no-page-found" element={<ErrorPage />} />
                <Route path="/*" element={<Navigate to="/no-page-found" replace />} />
                <Route path="/do-not-have-permmison" element={<PermissionDeny />} />
                <Route path="/" element={<Login />} />
                <Route path="/login" element={<Login />} />
                <Route path="/logout" element={<LogOut />} />
                <Route path="/forgot-password" element={<ForgetPassword />} />
                <Route path="/forgot-password/validate-link" element={<ChangedPassword />} />

                <Route element={<PrivateRoute showFor="support"><SupportDoc /></PrivateRoute>} path="/support">
                    <Route path="gebruikers" element={<Users />} />
                </Route>

                <Route element={<PrivateRoute showFor="documentbeheer"><SupportDoc /></PrivateRoute>} path="/">
                    <Route path="documentbeheer" element={<DocsGoedkeuren />} />
                </Route>

                <Route element={<EvaluationRequest />} path="/evaluation-request" />
                <Route path="/deep-link" element={<DeepLinkHandler />} />
            </Routes>
        </Fragment>
    )
};

export default AppMain;
